'use strict';

angular.module('directives.empStaging')

.controller('empStagingMatchingUpdatePendingPropertiesController', ['$scope', '$translate', 'employeeSyncService', function ($scope, $translate, employeeSyncService) {

    // Property Title Keys - maps property names to translation key suffixes
    var propertyTitleKeys = {
        'FirstName': 'firstName',
        'LastName': 'lastName',
        'Position_ENG': 'positionEng',
        'Position_FR': 'positionFr',
        'Department_ENG': 'departmentEng',
        'Department_FR': 'departmentFr',
        'JobStatus_ENG': 'jobStatusEng',
        'JobStatus_FR': 'jobStatusFr',
        'CompanyName': 'companyName',
        'DepartBudgCd': 'departBudgCd',
        'CommunicationLanguage': 'communicationLanguage',
        'Gender': 'gender',
        'OfficialFirstName': 'officialFirstName',
        'OfficialLastName': 'officialLastName',
        'Location': 'location',
        'ExpatType': 'expatType',
        'PersonalMobilePhone': 'personalMobilePhone',
		'PersonalEmail': 'personalEmail',
		'LegalEntity': 'legalEntity',
		'PayEntity': 'payEntity',
		'ChargebackEntity': 'chargebackEntity'
    };

    // Get Property Title
    $scope.getPropertyTitle = function (info) {
        var translationKey = propertyTitleKeys[info.Property];
        if (translationKey) {
            return $translate.instant('iam.shared.directives.empStaging.propertyTitles.' + translationKey);
        }
        return info.Property;
    };

    // Property display before and after
    var propertyDisplayBeforeAndAfter = {
        'PersonalMobilePhone': false,
        'PersonalEmail': false
    };

    $scope.getPropertyDisplayBeforeAndAfter = function (info) {
        if (propertyDisplayBeforeAndAfter[info.Property] === false) return false;
        return true;
    };

    // Get Infos on Employee Update Pending Properties
    employeeSyncService
             .getInfosOnEmployeeUpdatePendingProperties($scope.model)
             .then(function (infosOnEmployeeUpdateProperties) {
                 $scope.infosOnEmployeeUpdateProperties = infosOnEmployeeUpdateProperties;
             });

}]);